import { RequestStatus } from 'clickNgo/configs/service/common'

import { IMarketInfoState } from './models/IMarketInfoState'

export const initialState: IMarketInfoState = {
  data: {
    marketSector: {
      isPercentMode: false,
      public: 0,
      corporate: 0,
      middleMarket: 0,
      enterprise: 0,
      smb: 0,
      smbManaged: 0,
      smbUnmanaged: 0,
    },
    verticalMarket: {
      isPercentMode: false,
      centralGovernment: 0,
      education: 0,
      financialServices: 0,
      healthcare: 0,
      localGovernment: 0,
      manufacturing: 0,
      professionalServices: 0,
      retail: 0,
      telecommunications: 0,
      transportation: 0,
      utilities: 0,
      others: 0,
      comment: '',
    },
    marketLeasing: {
      isLeasingOffer: null,
      company1: '',
      company2: '',
      company3: '',
      devicesFunded: 0,
    },
  },
  status: RequestStatus.FULFILLED,
  message: '',
}
